import { ReactElement } from "react";
import { GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { MainLayout } from "~/components/layouts/MainLayout";
import { StandardServicePage } from "~/components/service-pages/StandardServicePage";
import { EvacuationFireProtectionInspectionContent as content } from "~/content/przeglad-zabezpieczen-ewakuacyjnych-i-przeciwpozarowych/content.pl";
import { getRecentPostsForService, type PostMeta } from "~/lib/mdx";
import { getServiceBySlug } from "~/lib/services";
import { NextPageWithLayout } from "~/pages/_app";
import smokeAlarmInspectionImage from "~/src/assets/images/smoke_4.jpg";
import smokeAlarmDetailImage from "~/src/assets/images/smoke-alarm-check.webp";
import smokeServiceImage from "~/src/assets/images/services-details-smoke.webp";

type Props = {
  recentPosts: PostMeta[];
};

const serviceSlug = "przeglad-zabezpieczen-ewakuacyjnych-i-przeciwpozarowych";
const service = getServiceBySlug(serviceSlug);

if (!service) {
  throw new Error(`Service not found: ${serviceSlug}`);
}

const pageUrl = `${(
  process.env.NEXT_PUBLIC_BASE_URL ?? "https://inspektomat.pl"
).replace(/\/+$/, "")}${service.href}`;

const sectionImages = [
  {
    src: smokeAlarmInspectionImage,
    alt: "Kontrola zabezpieczeń ewakuacyjnych i przeciwpożarowych",
  },
  {
    src: smokeAlarmDetailImage,
    alt: "Elementy zabezpieczeń ewakuacyjnych przygotowane do przeglądu",
  },
  {
    src: smokeServiceImage,
    alt: "Dokumentacja przeglądu zabezpieczeń ewakuacyjnych i przeciwpożarowych",
  },
] as const;

const EvacuationFireProtectionInspectionPage: NextPageWithLayout<Props> = ({
  recentPosts,
}) => {
  return (
    <StandardServicePage
      serviceSlug={serviceSlug}
      content={content}
      sectionImages={sectionImages}
      recentPosts={recentPosts}
    />
  );
};

EvacuationFireProtectionInspectionPage.getLayout = function GetLayout(
  page: ReactElement
) {
  return (
    <MainLayout>
      <NextSeo
        title={content.seo.title}
        description={content.seo.description}
        openGraph={{
          title: content.seo.title,
          description: content.seo.description,
          url: pageUrl,
        }}
      />
      {page}
    </MainLayout>
  );
};

export default EvacuationFireProtectionInspectionPage;

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      recentPosts: getRecentPostsForService(serviceSlug),
    },
  };
};
